import axios from "axios"
import { PrimaryButton } from "client/CommonComponents"

const AutoCompleteTest = () => {

    const apiCall = () => {
        const url = ``
        const response = axios.get(url).then(response => response.data).catch((error) => {
            console.log("Exception : ", error)
        });
        console.log("API URI Test : ", response)
    }

    return (
        <>
            <p>Auto Complete API URI Test</p>
            <PrimaryButton text="URL TEST" onClick={apiCall}  data-attribute="index_Default_Button_9" />
        </>
    )
}


export default AutoCompleteTest